import TermsUpdatedDialog from './TermsUpdatedDialog';

export default TermsUpdatedDialog;
